<template>
  <div class="ms-input ms-editor w-100" v-tooltip="hasTooltip() ? internalText : null">
    <div class="flex-row border" :class="{ error: errorProvider.isValid, disabled: disabled }">
      <div
        :class="['icon24 icon left', leftIcon]"
        v-if="leftIcon"
        :title="errorProvider.message"
      ></div>

      <input
        class="ms-input-item flex"
        :placeholder="placeholder"
        v-model="internalText"
        :disabled="disabled"
        :readonly="readOnly"
        :maxlength="maxLength"
        ref="input"
        :class="{ disabled: disabled }"
        v-on="listeners"
      />
      <div
        class="icon24 error error-icon"
        v-show="errorProvider.isValid && !isShowText"
        :title="errorProvider.message"
      ></div>
      <div :class="['icon24 icon right', rightIcon]" v-if="rightIcon"></div>
    </div>
    <div class="error-text" v-if="errorProvider.isValid && isShowText">
      {{ errorProvider.message }}
    </div>
  </div>
</template>
<script>
import msBaseComponent from "@/components/msbase/msBaseComponent.vue";
export default {
  extends: msBaseComponent,
  name: "msInput",
  props: {
    /**
     * V-model bắn ra ngoài binding 2 chiều
     */
    value: {
      default: null,
    },
    /**
     * Hiện thị chũ mờ ở dưới ô input
     * Created by LTDAT(22.06.2020)
     */
    placeholder: {
      default: null,
      type: [Number, String],
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    //icon left
    leftIcon: {
      default: null,
      type: String,
    },
    //icon right
    rightIcon: {
      default: null,
      type: String,
    },
    //input chỉ đọc không cho nhập
    readOnly: {
      default: false,
      type: Boolean,
    },
    //Giới hạn nhập của ô input
    maxLength: {
      default: null,
      type: Number,
    },
    isShowText: {
      type: Boolean,
      default: true,
    },
    /*
     * Hàm show ra câu thông báo riêng theo từng trường hợp
     * pvduy 18/03/2021
     * ví dụ: customWarring {rules:'required', mes: 'Tài sản này là của pvduy'}
     */
    customWarring: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      internalText: this.value,
      focused: false,
      displayValue: null,
      scrollWidth: 0,
    };
  },
  computed: {
    listeners() {
      return {
        blur: (e) => {
          this.onBlur(e);
        },
        focus: (e) => {
          this.onFocus(e);
        },
        change: (e) => {
          this.$emit("change", this.internalText, e);
        },
        keydown: (e) => {
          this.$emit("keydown", e);
        },
        keyup: (e) => {
          this.$emit("keyup", e);
        },
      };
    },
    // hasTooltip() {
    // 	const me = this;
    // 	if (me.$refs.input && me.scrollWidth > me.$refs.input.offsetWidth) {
    // 		return true;
    // 	}
    // 	return false;
    // }
  },
  methods: {
    hasTooltip() {
      const me = this;
      if (
        me.$refs.input &&
        me.scrollWidth > me.$refs.input.offsetWidth &&
        me.validateSpecialInput(me.internalText)
      ) {
        return true;
      }
      return false;
    },
    //Sự kiện focus vào ô input
    onFocus(e) {
      const me = this;
      me.focused = true;
      me.$emit("focus", e);
    },
    //Sự kiên blur ra ngoài ô input
    onBlur(e) {
      const me = this;
      me.focused = false;
      me.$emit("blur", e);
    },
    //Reset lại giá trị về ban đầu
    reset() {
      const me = this;
      me.internalText = null;
      me.displayValue = null;
    },
    //Set giá trị cho ô input
    setValue(value) {
      const me = this;
      if (me.rules) {
        let listRules = me.rules.split("|");
        if (value && listRules.includes("phone")) {
          value = value.replace(/ /g, "").replace(/\./g, "");
        }
      }
      me.internalText = value;
    },
  },
  watch: {
    internalText: {
      handler(newVal, oldVal) {
        const me = this;
        me.$emit("input", newVal);
        me.$nextTick(() => {
          this.validate(this);
        });
        me.scrollWidth = me.$refs.input.scrollWidth;
      },
    },
    value: {
      immediate: true,
      handler(newVal, oldVal) {
        const me = this;
        me.setValue(newVal);
      },
    },
    disabled: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.validate(this);
        }
      },
    },
  },
};
</script>
<style lang="scss" scoped>
// @media screen and (max-width: 1366px) {
// 	@import '@/assets/scss/_sm-variables.scss';
// 	@import '@/assets/scss/components/msInput.scss';
// }
// @media screen and (min-width: 1367px) {
// 	@import '@/assets/scss/_variables.scss';
// 	@import '@/assets/scss/components/msInput.scss';
// }

@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/components/msInput.scss";
</style>
